const routes = [
  {
    path: '/',
    component: () => import('layouts/EmptyLayout.vue'),
    redirect: '/login',
    children: [{
      path: 'login/:param?',
      name: 'login',
      component: () => import('pages/LoginPage.vue'),
      beforeEnter: (to, from, next) => {
        // reset all stores on navigation to login
        // store.commit('reset')
        next()
      },
      meta: {
        requiresAuth: false,
        modul: 'kdb'
      }
    }]
  },
  {
    path: '/Kunden',
    name: 'kdb',
    component: () => import('layouts/MainLayoutM3.vue'),
    redirect: { name: 'CustomerMask_kdb' },
    children: [{
      path: ':clientId?/Kundenmaske',
      name: 'CustomerMask_kdb',
      component: () => import('pages/Global/CustomerMask.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kdb',
        title: 'leftMenu.customer_mask',
        searchTitle: 'leftMenu.customer_mask_search'
      }
    }, {
      path: 'Kundenliste',
      name: 'CustomerList_kdb',
      component: () => import('pages/Kdb/CustomerList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kdb',
        title: 'clientList.title'
      }
    },
    {
      path: 'Firmenliste',
      name: 'CompanyList_kdb',
      component: () => import('pages/Kdb/CompanyList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kdb',
        title: 'companyList.title'
      }
    },
    {
      path: 'BriefeUndMails',
      name: 'LettersMails_kdb',
      component: () => import('pages/Global/LettersMailsPage.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kdb',
        title: 'leftMenu.letters_and_emails'
      }
    }]
  },
  {
    path: '/FMV',
    name: 'fmv',
    component: () => import('layouts/MainLayoutM3.vue'),
    redirect: { name: 'CustomerMask_fmv' },
    children: [{
      path: ':clientId?/Mitgliedermaske',
      name: 'CustomerMask_fmv',
      component: () => import('pages/Global/CustomerMask.vue'),
      meta: {
        requiresAuth: true,
        modul: 'fmv',
        title: 'leftMenu.member_mask',
        searchTitle: 'leftMenu.member_mask_search'
      }
    },
    {
      path: 'Mitgliederliste',
      name: 'CustomerList_fmv',
      component: () => import('pages/Fmv/CustomerList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'fmv',
        title: 'clientList.title'
      }
    },
    {
      path: 'Firmenliste',
      name: 'CompanyList_fmv',
      component: () => import('pages/Fmv/CompanyList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'fmv',
        title: 'companyList.title'
      }
    },
    {
      path: 'BriefeUndMails',
      name: 'LettersMails_fmv',
      component: () => import('pages/Global/LettersMailsPage.vue'),
      meta: {
        requiresAuth: true,
        modul: 'fmv',
        title: 'leftMenu.letters_and_emails'
      }
    },
    {
      path: 'Jahresquittungen',
      name: 'AnnualReceipts_fmv',
      component: () => import('pages/Fmv/AnnualReceiptList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'fmv',
        title: 'leftMenu.annual_receipt'
      }
    }
    ]
  },
  {
    path: '/Kurse',
    name: 'ktv',
    component: () => import('layouts/MainLayoutM3.vue'),
    redirect: { name: 'CourseSummary' },
    children: [{
      path: 'Kursuebersicht',
      alias: ['Kursübersicht', 'Kurs%C3%BCbersicht'],
      name: 'CourseSummary',
      component: () => import('pages/Course/CourseSummary.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv'
      }
    },
    {
      path: 'Kursmaterialien',
      name: 'CourseMaterials',
      component: () => import('pages/Course/CourseMaterials.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'courseMaterials.title'
      }
    },
    {
      path: 'Kursgrundeinstellungen',
      name: 'CourseBasicSettings',
      component: () => import('pages/Course/BasicSettings/index.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'routes.course_basic_settings'
      }
    },
    {
      path: 'Fachlehrkraefte',
      alias: ['Fachlehrkräfte', 'Fachlehrkr%C3%A4fte'],
      name: 'CourseTeachersKtv',
      component: () => import('pages/Course/CourseTeachers.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'courseTeachers.title'
      }
    },
    {
      path: 'Fachlehrkraefte/:teacherUid',
      name: 'CourseTeacherDetailKtv',
      component: () => import('pages/Course/CourseTeacherDetail.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'teacherMask.title'
      }
    },
    {
      path: 'Kundenliste',
      name: 'CustomerListKtv',
      component: () => import('pages/Course/CustomerList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'clientList.title'
      }
    },
    {
      path: 'Firmenliste',
      name: 'CompanyListKtv',
      component: () => import('pages/Course/CompanyList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'companyList.title'
      }
    },
    {
      path: 'BgListe',
      name: 'BgList',
      component: () => import('pages/Course/BgList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'bgList.title'
      }
    },
    {
      path: 'BgListe/:bgListId',
      name: 'BgListDetail',
      component: () => import('pages/Course/BgListDetail.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'bgListMask.title'
      }
    },
    {
      // Optional segments keep the journal state: Archiv[/<id>], Archiv-alt[/<id>],
      // Nicht-gebucht[/Entwurf|Rechnung/<id>] (see useInvoiceJournalUrlState).
      path: 'Rechnungsjournal/:journalPath*',
      name: 'InvoiceJournalKtv',
      component: () => import('pages/Course/InvoiceJournal.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'leftMenu.invoice_journal'
      }
    },
    {
      path: 'Marketingtool',
      name: 'MarketingToolKtv',
      component: () => import('pages/Course/MarketingTool.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'leftMenu.marketing_tool'
      }
    },
    {
      path: ':clientId?/Teilnehmermaske',
      name: 'CustomerMask_ktv',
      component: () => import('pages/Global/CustomerMask.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'leftMenu.subscriber_mask',
        searchTitle: 'leftMenu.subscriber_mask_search'
      }
    },
    {
      path: ':courseId/Stammdaten',
      name: 'CourseRootKtv',
      component: () => import('pages/Ktv/CourseRootData.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv'
      }
    },
    {
      path: ':courseId/Termine',
      name: 'CourseDatesKtv',
      component: () => import('pages/Ktv/CourseDates.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv'
      }
    },
    {
      path: ':courseId/Fachlehrkrafttage',
      alias: ':courseId/Dozententage',
      name: 'CourseTeacherKtv',
      component: () => import('pages/Ktv/CourseTeacher.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv'
      }
    },
    {
      path: ':courseId/Teilnehmer',
      name: 'CourseSubscriberKtv',
      component: () => import('pages/Ktv/CourseSubscriber.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv'
      }
    },
    {
      path: 'BriefeUndMails',
      name: 'LettersMails_ktv',
      component: () => import('pages/Global/LettersMailsPage.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ktv',
        title: 'leftMenu.letters_and_emails'
      }
    }]
  },
  {
    path: '/Akademie',
    // Legacy module URL; the percent-encoded variant is needed because the
    // matcher compares the raw (encoded) hash path, like 'Kurs%C3%BCbersicht'.
    alias: ['/KTV Schulen', '/KTV%20Schulen'],
    name: 'ls',
    component: () => import('layouts/MainLayoutM3.vue'),
    redirect: { name: 'CourseSummary' },
    children: [{
      path: 'Kundenliste',
      name: 'CustomerListLs',
      component: () => import('pages/Course/CustomerList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls',
        title: 'clientList.title'
      }
    },
    {
      path: 'Firmenliste',
      name: 'CompanyListLs',
      component: () => import('pages/Course/CompanyList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls',
        title: 'companyList.title'
      }
    },
    {
      path: 'BgListe',
      name: 'BgListLs',
      component: () => import('pages/Course/BgList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls',
        title: 'bgList.title'
      }
    },
    {
      path: 'BgListe/:bgListId',
      name: 'BgListDetailLs',
      component: () => import('pages/Course/BgListDetail.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls',
        title: 'bgListMask.title'
      }
    },
    {
      // Optional segments keep the journal state: Archiv[/<id>], Archiv-alt[/<id>],
      // Nicht-gebucht[/Entwurf|Rechnung/<id>] (see useInvoiceJournalUrlState).
      path: 'Rechnungsjournal/:journalPath*',
      name: 'InvoiceJournalLs',
      component: () => import('pages/Course/InvoiceJournal.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls',
        title: 'leftMenu.invoice_journal'
      }
    },
    {
      path: 'Marketingtool',
      name: 'MarketingToolLs',
      component: () => import('pages/Course/MarketingTool.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls',
        title: 'leftMenu.marketing_tool'
      }
    },
    {
      path: 'Fachlehrkraefte',
      alias: ['Fachlehrkräfte', 'Fachlehrkr%C3%A4fte'],
      name: 'CourseTeachersLs',
      component: () => import('pages/Course/CourseTeachers.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls',
        title: 'courseTeachers.title'
      }
    },
    {
      path: 'Fachlehrkraefte/:teacherUid',
      name: 'CourseTeacherDetailLs',
      component: () => import('pages/Course/CourseTeacherDetail.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls',
        title: 'teacherMask.title'
      }
    },
    {
      path: 'Kursmaterialien',
      name: 'CourseMaterialsLs',
      component: () => import('pages/Course/CourseMaterials.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls',
        title: 'courseMaterials.title'
      }
    },
    {
      path: 'Kursgrundeinstellungen',
      name: 'CourseBasicSettingsLs',
      component: () => import('pages/Course/BasicSettings/index.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls',
        title: 'routes.course_basic_settings'
      }
    },
    {
      path: ':courseId/Stammdaten',
      name: 'CourseRootLs',
      component: () => import('pages/Ktv/CourseRootData.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls'
      }
    },
    {
      path: ':courseId/Termine',
      name: 'CourseDatesLs',
      component: () => import('pages/Ktv/CourseDates.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls'
      }
    },
    {
      path: ':courseId/Fachlehrkrafttage',
      alias: ':courseId/Dozententage',
      name: 'CourseTeacherLs',
      component: () => import('pages/Ktv/CourseTeacher.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls'
      }
    },
    {
      path: ':courseId/Teilnehmer',
      name: 'CourseSubscriberLs',
      component: () => import('pages/Ktv/CourseSubscriber.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls'
      }
    },
    {
      path: 'BriefeUndMails',
      name: 'LettersMails_ls',
      component: () => import('pages/Global/LettersMailsPage.vue'),
      meta: {
        requiresAuth: true,
        modul: 'ls',
        title: 'leftMenu.letters_and_emails'
      }
    }]
  },
  {
    path: '/Familie',
    alias: ['/KTV KiFam', '/KTV%20KiFam'],
    name: 'kifam',
    component: () => import('layouts/MainLayoutM3.vue'),
    redirect: { name: 'CourseSummary' },
    children: [{
      path: 'Kundenliste',
      name: 'CustomerListKifam',
      component: () => import('pages/Course/CustomerList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam',
        title: 'clientList.title'
      }
    },
    {
      path: 'Firmenliste',
      name: 'CompanyListKifam',
      component: () => import('pages/Course/CompanyList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam',
        title: 'companyList.title'
      }
    },
    {
      path: 'BgListe',
      name: 'BgListKifam',
      component: () => import('pages/Course/BgList.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam',
        title: 'bgList.title'
      }
    },
    {
      path: 'BgListe/:bgListId',
      name: 'BgListDetailKifam',
      component: () => import('pages/Course/BgListDetail.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam',
        title: 'bgListMask.title'
      }
    },
    {
      // Optional segments keep the journal state: Archiv[/<id>], Archiv-alt[/<id>],
      // Nicht-gebucht[/Entwurf|Rechnung/<id>] (see useInvoiceJournalUrlState).
      path: 'Rechnungsjournal/:journalPath*',
      name: 'InvoiceJournalKifam',
      component: () => import('pages/Course/InvoiceJournal.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam',
        title: 'leftMenu.invoice_journal'
      }
    },
    {
      path: 'Marketingtool',
      name: 'MarketingToolKifam',
      component: () => import('pages/Course/MarketingTool.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam',
        title: 'leftMenu.marketing_tool'
      }
    },
    {
      path: 'Fachlehrkraefte',
      alias: ['Fachlehrkräfte', 'Fachlehrkr%C3%A4fte'],
      name: 'CourseTeachersKifam',
      component: () => import('pages/Course/CourseTeachers.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam',
        title: 'courseTeachers.title'
      }
    },
    {
      path: 'Fachlehrkraefte/:teacherUid',
      name: 'CourseTeacherDetailKifam',
      component: () => import('pages/Course/CourseTeacherDetail.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam',
        title: 'teacherMask.title'
      }
    },
    {
      path: 'Kursmaterialien',
      name: 'CourseMaterialsKifam',
      component: () => import('pages/Course/CourseMaterials.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam',
        title: 'courseMaterials.title'
      }
    },
    {
      path: 'Kursgrundeinstellungen',
      name: 'CourseBasicSettingsKifam',
      component: () => import('pages/Course/BasicSettings/index.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam',
        title: 'routes.course_basic_settings'
      }
    },
    {
      path: ':courseId/Stammdaten',
      name: 'CourseRootKifam',
      component: () => import('pages/Ktv/CourseRootData.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam'
      }
    },
    {
      path: ':courseId/Termine',
      name: 'CourseDatesKifam',
      component: () => import('pages/Ktv/CourseDates.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam'
      }
    },
    {
      path: ':courseId/Fachlehrkrafttage',
      alias: ':courseId/Dozententage',
      name: 'CourseTeacherKifam',
      component: () => import('pages/Ktv/CourseTeacher.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam'
      }
    },
    {
      path: ':courseId/Teilnehmer',
      name: 'CourseSubscriberKifam',
      component: () => import('pages/Ktv/CourseSubscriber.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam'
      }
    },
    {
      path: 'BriefeUndMails',
      name: 'LettersMails_kifam',
      component: () => import('pages/Global/LettersMailsPage.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kifam',
        title: 'leftMenu.letters_and_emails'
      }
    }]
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('layouts/MainLayoutM3.vue'),
    redirect: '/main/welcome',
    children: [{
      path: 'welcome',
      name: 'welcome',
      component: () => import('pages/WelcomePage.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kdb'
      }
    }, {
      path: 'queue-mercure-sample',
      name: 'queueMercureSample',
      component: () => import('pages/CliSampleDemoPage.vue'),
      meta: {
        requiresAuth: true,
        modul: 'kdb',
        title: 'cliSampleDemo.routeTitle'
      }
    }, {
      path: 'Vereinsdaten/:moduleSlug?',
      name: 'OrganisationSettings',
      component: () => import('pages/Settings/OrganisationSettings.vue'),
      meta: {
        requiresAuth: true,
        title: 'organisationSettings.title'
      }
    }, {
      path: 'Schnittstellen/:moduleSlug?',
      name: 'InterfaceSettings',
      component: () => import('pages/Settings/InterfaceSettings.vue'),
      meta: {
        requiresAuth: true,
        title: 'interfaceSettings.title'
      }
    }, {
      path: 'Layout',
      name: 'LayoutSettings',
      component: () => import('pages/Settings/LayoutSettings.vue'),
      meta: {
        requiresAuth: true,
        title: 'layoutSettings.title'
      }
    }, {
      path: 'Suche/:moduleSlug?',
      name: 'ClientSearch',
      component: () => import('pages/Settings/ClientSearchPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'listOverview.tabs.search'
      }
    }]
  },
  /*{
    path: '/test',
    name: 'test',
    component: () => import('layouts/EmptyLayout.vue'),
    // redirect: '/main/welcome',
    children: [{
      path: '/test',
      name: 'testcomponent',
      component: () => import('pages/TestPage.vue'),
    }]
  },*/
  // otherwise redirect to home
  { path: '/:catchAll(.*)*', name: 'notFound', redirect: '/login' }
]

export default routes
